import { render, staticRenderFns } from "./source_editor.vue.js?vue&type=template&id=163bdea6&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./source_editor.vue?vue&type=template&id=163bdea6&vue3"
import script from "./source_editor.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./source_editor.vue?vue&type=script&lang=js&vue3"
export * from "./source_editor.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./source_editor.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports